// A connection's cable length, for its card, the connection table and the
// electrical schematic (TODO.md, *Electrical schematic on a sheet*, decision 10):
// the length typed by hand, else its run as the 3D view draws it — a schematic
// connection up from each end to its run height, along its route and down
// (`connGeom`'s run length), + 20 %, rounded up to the metre; a pipe's own length
// along it, exact. DOM-free (unit-tested).
import type {
  Connection,
  Drawing,
} from '../shared/types';
import { connGeom } from './connections';

/** What a worked-out length is grown by: the cable's slack, its terminations. */
export const CABLE_ALLOWANCE = 1.2;

/** Whether a connection's length is worked out (none typed by hand). */
export function isComputedLength(c: Connection): boolean {
  return !(typeof c.length === 'number' && Number.isFinite(c.length) && c.length >= 0);
}

/** The run's exact length (mm) as the 3D view draws it: a pipe's along it, its
 *  elbows' arcs included (a hose's along its curve); a schematic connection's
 *  up its risers, along its run and down. 0 when an end is gone. */
export function connectionRunLength(d: Drawing, c: Connection): number {
  return connGeom(d, c)?.runLength ?? 0;
}

/** A connection's length in mm: the typed one, else a pipe's run to the mm, a
 *  cable's run + 20 % rounded UP to the whole metre. */
export function connectionLength(d: Drawing, c: Connection): number {
  if (!isComputedLength(c)) return c.length!;
  const g = connGeom(d, c);
  if (!g) return 0;
  if (g.pipe) return Math.round(g.runLength);
  return Math.max(0, Math.ceil((g.runLength * CABLE_ALLOWANCE) / 1000 - 1e-9)) * 1000;
}

/** A cable length as the tables show it: whole metres ("10 m"), else to the
 *  centimetre a typed length or a pipe needs. */
export function formatCableLength(mm: number): string {
  const m = mm / 1000;
  return `${Number.isInteger(m) ? m : Math.round(m * 100) / 100} m`;
}
